
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games",
      function () {
        return require("private-next-pages/games.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games"])
      });
    }
  